"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21.521 32", width: "1em", height: "1em", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.729 25.726a.5.5 0 01-.408-.21l-1.209-1.699H9.474l-1.209 1.699a.507.507 0 01-.55.189 10.815 10.815 0 01-4.336-2.511.502.502 0 01-.111-.572l.864-1.89-1.319-2.285-2.071-.197a.5.5 0 01-.438-.382A10.88 10.88 0 010 15.363c0-.815.103-1.658.304-2.505a.499.499 0 01.438-.383l2.071-.197 1.319-2.284-.864-1.89a.502.502 0 01.111-.572 10.815 10.815 0 014.336-2.511.504.504 0 01.55.189l1.209 1.699h2.638l1.209-1.699a.5.5 0 01.55-.189 10.832 10.832 0 014.337 2.511c.155.148.2.377.111.572l-.865 1.89 1.319 2.284 2.071.197a.5.5 0 01.438.382c.202.846.305 1.689.305 2.506s-.103 1.66-.305 2.505a.5.5 0 01-.438.382l-2.071.197-1.319 2.285.865 1.89a.502.502 0 01-.111.572 10.832 10.832 0 01-4.337 2.511.498.498 0 01-.142.021zm-9.4-3.019a9.825 9.825 0 003.332 1.932l1.148-1.612a.497.497 0 01.407-.21h3.154c.162 0 .314.078.407.21l1.148 1.612a9.823 9.823 0 003.333-1.932l-.82-1.794a.498.498 0 01.022-.458l1.577-2.731a.499.499 0 01.385-.248l1.965-.187c.133-.652.2-1.299.2-1.926s-.067-1.274-.2-1.927l-1.965-.187a.499.499 0 01-.385-.248l-1.577-2.73a.498.498 0 01-.022-.458l.82-1.794a9.823 9.823 0 00-3.333-1.932l-1.148 1.612a.497.497 0 01-.407.21H9.216a.497.497 0 01-.407-.21L7.661 6.087a9.825 9.825 0 00-3.332 1.932l.819 1.794a.498.498 0 01-.022.458l-1.577 2.73a.499.499 0 01-.385.248l-1.964.187a9.69 9.69 0 00-.2 1.927c0 .626.067 1.273.2 1.926l1.964.187c.16.015.305.108.385.248l1.577 2.731c.081.14.09.311.022.458l-.819 1.794zm6.464-2.282c-2.791 0-5.062-2.271-5.062-5.062s2.271-5.062 5.062-5.062 5.062 2.271 5.062 5.062-2.271 5.062-5.062 5.062zm0-9.124c-2.239 0-4.062 1.822-4.062 4.062s1.823 4.062 4.062 4.062 4.062-1.822 4.062-4.062-1.823-4.062-4.062-4.062z" })));
};
var SvgSettings = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgSettings;
var templateObject_1;
